import { Card } from "antd";

const CityRulesCard = () => {
  return (
    <Card title="城市玩法">
      <ul className="text-secondary city-rules-card">
        <li>每个城市由该城市的版主和本地小组志愿维护</li>
        <li>我们会不断丰富城市里的内容、工作还有活动</li>
        <li>从而帮助更多的青年回乡工作、可远程可旅居</li>
        <li>请尊重社区规则和我们的劳动，热爱你的城市</li>
      </ul>
    </Card>
  );
};
export default CityRulesCard;
